import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, Input, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { switchMap, debounceTime, tap, finalize, catchError, map } from 'rxjs/operators';
import { Honeycomb } from 'src/app/shared/honeycomb-api/honeycomb-api';
import { isNullOrWhitespace } from '../functions';

@Component({
    selector: 'hc-user-job-suggester',
    templateUrl: './user-job-suggester-component.html',
    styleUrls: ['./user-job-suggester-component.scss']
})
export class UserJobSuggesterComponent implements OnInit {

    @Output() public onUserJobSelected: EventEmitter<Honeycomb.Tenant.Contact.IService.SimpleUserJob> = new EventEmitter();
    @Input() public label = 'admin.web.search';
    @Input() public clearAfterSelection = true;
    @Input() public display: string;

    @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
    foundUsers: Honeycomb.Tenant.Contact.IService.SimpleUserJob[] = [];
    searchForm: FormGroup;
    isLoading = false;

    constructor(private fb: FormBuilder,
                @Inject('JobController') private jobController: Honeycomb.Tenant.Contact.IService.Controller.JobController,
                private changeRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.searchForm = this.fb.group({
            searchInput: null
        });

        this.searchForm
            .get('searchInput')
            .valueChanges
            .pipe(
                debounceTime(300),
                tap(() => this.isLoading = true),
                map(async (value) => {
                    if (isNullOrWhitespace(value)) {
                        this.isLoading = false;
                        if (this.onUserJobSelected) {
                            this.onUserJobSelected.emit(null);
                        }
                        return [];
                    } else {
                        this.foundUsers = await 
                        lastValueFrom(this.jobController.JobUsers(1, false, value)
                        .pipe(
                            catchError(_ => []),
                            finalize(() => {
                                this.isLoading = false;
                            }),
                        ))
                        .catch(_ => { return []; });
                        return this.foundUsers;
                    }
                })
            )
            .subscribe(async res => {
                this.foundUsers = await res;
                this.changeRef.detectChanges();
            });
    }

    public valueSelected($event) {
        if (!$event.option) {
            return;
        }
        let user = <Honeycomb.Tenant.Contact.IService.SimpleUserJob>$event.option.value;
        if (this.onUserJobSelected) {
            this.onUserJobSelected.emit(user);
        }
        if (this.clearAfterSelection) {
            this.searchInput.nativeElement.value = '';
            this.searchInput.nativeElement.focus();
        } else {
            this.searchInput.nativeElement.value = $event.option.viewValue;
        }
    }

    public displayFn(user: Honeycomb.Tenant.Contact.IService.SimpleUserJob) {
        if (user) { return `${user.user.name} (${user.job.name})`; }
    }
}
